import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import {
  MOBILE_SCREEN_WIDTH,
  TAB_SCREEN_WIDTH,
} from "../../../utils/constants";
import { useNationalLeagueStore } from "../../../store/StoreContext";
import { useFontDesk } from "../../../context/frontDeskContext";
import { League } from "./League";

type props = {};

export const AllNationalLeagues: React.FC<props> = observer(() => {
  const nationalLeagueStore = useNationalLeagueStore();
  const { isMobile, isTab, setIsMobile, setIsTab } = useFontDesk();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_SCREEN_WIDTH);
      setIsTab(window.innerWidth < TAB_SCREEN_WIDTH && !isMobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, setIsMobile, setIsTab]);

  return (
    <>
      {nationalLeagueStore.leagues.length === 0 &&
        !nationalLeagueStore.isLoading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ marginTop: 20 }}>
            <p className="text-center" style={{ fontSize: "1.2rem" }}>
              No leagues found
            </p>
          </div>
        )}
      <div
        // ref={listRef}
        // onScroll={handleScroll}
        style={{
          marginTop: 20,
          display: isMobile ? "flex" : "grid",
          gridTemplateColumns: (() => {
            if (isMobile) return "1fr";
            if (isTab) return "repeat(1, 1fr)";
            // desktop
            return nationalLeagueStore.leagues.length === 1
              ? "1fr"
              : "repeat(2, 1fr)";
          })(),
          gap: isMobile ? "25px" : "25px 25px", // row-gap 15px, column-gap 25px for desktop
          flexDirection: isMobile ? "column" : undefined,
          padding: "0 16px",
          width: "100%",
          overflowY: "auto",
        }}>
        {nationalLeagueStore.leagues.map((league, idx) => {
          const isSingleCentered =
            !isMobile && nationalLeagueStore.leagues.length === 1;
          return (
            <div
              key={league.id}
              style={{
                maxWidth: isSingleCentered ? 800 : "100%",
                margin: isSingleCentered ? "0 auto" : undefined,
                width: "100%",
              }}>
              <League league={league} />
            </div>
          );
        })}
      </div>
    </>
  );
});
